export default {
  API_ENDPOINT: 'https://obscure-castle-34709.herokuapp.com/api'
  
}


//http://localhost:8000/api
//https://obscure-castle-34709.herokuapp.com/api